import { serviceCategoryLabels } from "../rfqs/api.js";
import { useContractorProfilesList } from "../contractorProfiles/api.js";

export function ContractorSubmissionsReview() {
  const query = useContractorProfilesList();

  const items = [...(query.data ?? [])].sort((a, b) => b.createdAt.localeCompare(a.createdAt));

  return (
    <main className="mx-auto w-full max-w-4xl p-4 sm:p-6">
      <h1 className="text-2xl font-semibold text-slate-900">Contractor submissions</h1>
      <p className="mt-2 text-sm text-slate-600">Review all contractor intake form responses.</p>

      {query.isLoading && <p className="mt-4 text-sm text-slate-500">Loading...</p>}

      {query.isError && (
        <p className="mt-4 text-sm text-rose-700">
          Failed to load submissions. {query.error instanceof Error ? query.error.message : ""}
        </p>
      )}

      {query.data && query.data.length === 0 && (
        <div className="mt-4 rounded-lg border border-slate-200 bg-white p-4 text-sm text-slate-600">
          No submissions yet.
        </div>
      )}

      <ul className="mt-4 space-y-3">
        {items.map((item) => (
          <li key={item.id} className="rounded-lg border border-slate-200 bg-white p-4">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <h2 className="text-base font-semibold text-slate-900">{item.businessName}</h2>
                <p className="text-sm text-slate-600">
                  {item.contactName} · {item.phone} · {item.email}
                </p>
                {item.website && <p className="text-sm text-slate-600">Website: {item.website}</p>}
              </div>
              <p className="text-xs text-slate-500">
                Submitted {new Date(item.createdAt).toLocaleString()}
              </p>
            </div>

            <p className="mt-3 text-sm text-slate-700">
              <span className="font-medium">Service area:</span> {item.serviceArea}
            </p>
            <p className="text-sm text-slate-700">
              <span className="font-medium">Experience:</span> {item.yearsExperience} years
            </p>
            <p className="mt-2 text-sm text-slate-700">
              <span className="font-medium">Categories:</span>{" "}
              {item.serviceCategories.map((category) => serviceCategoryLabels[category]).join(", ")}
            </p>

            {item.licenseInfo && (
              <p className="mt-2 text-sm text-slate-700">
                <span className="font-medium">License:</span> {item.licenseInfo}
              </p>
            )}
            {item.insuranceInfo && (
              <p className="mt-1 text-sm text-slate-700">
                <span className="font-medium">Insurance:</span> {item.insuranceInfo}
              </p>
            )}
            {item.about && (
              <p className="mt-2 text-sm text-slate-700">
                <span className="font-medium">About:</span> {item.about}
              </p>
            )}
            {item.notes && (
              <p className="mt-1 text-sm text-slate-700">
                <span className="font-medium">Notes:</span> {item.notes}
              </p>
            )}
          </li>
        ))}
      </ul>
    </main>
  );
}
